"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  ADD: "@@site/add",
  EDIT_SAVE: "@@site/edit-save",
  EDIT_SAVE_RESET: "@@site/edit-save-reset",
  EDIT: "@@site/edit",
  READ: "@@site/read",
  CHANGE: "@@site/change",
  RESET_CHANGE: "@@site/reset-change",
  UPDATE: "@@site/update",
  LIST: "@@site/list",
  LIST_REVIEW_APPROVAL: "@@site/list-review-approval",
  SUBMIT: "@@site/submit",
  APPROVE: "@@site/approve",
  DELETE: "@@site/delete",
  CLONE: "@@site/clone",
  SAVE: "@@site/save",
  BUILD_LIST: "@@site/build-list",
  FILTER: "@@site/filter",
  PAUSE: "@@site/pause",
  PLAY: "@@site/play",
  COPY_URL: "@@site/copyUrl",
  DOWNLOAD_EMAIL: "@@site/download-email",
  RESTRICT: "@@site/restrict",
  UNRESTRICT: "@@site/unrestrict",
  VIEW_SNAPSHOTS: "@@site/view-snapshots",
  VIEW_EDITOR_LIST: "@@site/view-editor-list",
  VIEW_CONFIG: "@@site/view-config",
  SUCCESS: "@@site/success",
  ERROR: "@@site/error",
  RESET: "@@site/reset",
  RESET_WITHOUT_LIST: "@@site/reset-list"
};
exports.actionTypes = actionTypes;